import { useLogout } from 'hooks/api/useUser';
import { useTranslation } from 'react-i18next';
import { useSearchParameters } from 'hooks/useSearchParameters';
import { queryKeys } from 'utils/query';
import { SimpleErrorModal } from './SimpleErrorModal';

export const WrongAccountModal = () => {
  const { t } = useTranslation();
  const { mutate: logout } = useLogout();
  const { parameters: filters, setParameters } = useSearchParameters(queryKeys.worklistOverview);

  return (
    <SimpleErrorModal
      title={t('wrong_account_title')}
      description={t('wrong_account_description')}
      buttonText={t('return_to_login_button')}
      buttonAction={() => logout({})}
      secondButton={{
        text: t('wrong_account_continue'),
        action: () => {
          setParameters({ ...filters, groups: '' });
        },
      }}
    />
  );
};
